import React from 'react'

/*
	* React banner logos for gamheaders
	*
	* @param  	{String} options.teamId  	Unique key to force lazyload plugin to update <img/>.src
	* @param  	{Array} options.bannerLogo  Logo URLs for teams
	* @return 	{React.PropTypes.element} 	BannerPicture element
*/

const BannerPicture = ({
	teamId,
	bannerLogo = ''
}) => {
  return (
	<div>
		<picture>
			<video style={{ display: 'none' }}>
				<source srcSet={bannerLogo} />
			</video>
			<img  key={teamId} data-default-src={bannerLogo} className="team-logo lazyload" data-src={bannerLogo} />
		</picture>
		<svg className="team__svg team__svg--primary" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 176 80">
			<defs>
				<linearGradient id="linear-gradient" x1="108.61" y1="752.49" x2="90.78" y2="770.32" gradientTransform="translate(-5 -710)" gradientUnits="userSpaceOnUse">
					<stop offset="0" stopOpacity="0"/>
					<stop offset="1"/>
				</linearGradient>
			</defs>
			<polygon className="team__stroke" points="81 80 80 80 0 0 1 0 81 80"/>
			<polygon className="team__gradient" points="170.1 80 122.1 80 42.1 0 90.1 0 170.1 80"/>
		</svg>

		<svg className="team__svg team__svg--left" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 176 80">
			<polygon className="team__left" points="0 80 80 80 0 0 0 80"/>
		</svg>

		<svg className="team__svg team__svg--right" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 176 80">
			<polygon className="team__right" points="176 0 96 0 176 80 176 0"/>
		</svg>
	</div>
  )
}

module.exports = BannerPicture



// WEBPACK FOOTER //
// ../app/components/common/BannerPicture.jsx